import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import NewPage from "./NewPage";
import ScrollToTop from "./routes/ScrollToTop";
import NewApp from "./routes/newApp/NewAppRoute";
import NewHomeRoute from "./routes/newHomeRoute/NewHomeRoute";
import NewMarketplaceRoute from "./routes/newMarketplaceRoute/NewMarketplaceRoute";
import NewPricingRoute from "./routes/newPricing/NewPricingRoute";
// Legacy use-case route components remain in src/routes/newUseCasesRoute/
// (NewUseCasesRoute, NewBikeSharingRoute, NewDesignYourOwnRoute) and in
// src/routes/NewBikeParkingRoute/. They are no longer routed — /use-cases/*
// now redirects to the /industries anchors.
import NewIndustriesRoute from "./routes/newIndustriesRoute/NewIndustriesRoute";
import NewReferencesRoute from "./routes/newReferencesRoute/NewReferencesRoute";
import NewTeamRoute from "./routes/newTeamRoute/NewTeamRoute";
import NewMeetingRoute from "./routes/newMeetingRoute/NewMeetingRoute";
import NewWebAppRoute from "./routes/newWebAppRoute/newWebAppRoute";
import ProductDetailPage from "./routes/newMarketplaceRoute/[slug]/ProductPage";
import NewBikeParkingShowroomRoute from "./routes/newBikeParkingShowroomRoute/NewBikeParkingShowroomRoute";
import NewBillingRoute from "./routes/newBillingRoute/NewBillingRoute";
import NewDocsRoute from "./routes/newDocs/NewDocsRoute";
import NewIdentityRoute from "./routes/newIdentityRoute/NewIdentityRoute";
import NewDigitalTwinsRoute from "./routes/newDigitalTwinsRoute/NewDigitalTwinsRoute";
import BikeParkingRoute from "./routes/NewBikeParkingRoute/BikeParkingRoute";
import NewLockingSystemsRoute from "./routes/newLockingSystemsRoute/NewLockingSystemsRoute";
import NewMap from "./routes/newMap/NewMapRoute";
import SmartCityRoute from "./routes/smartCityRoute/SmartCityRoute";
import QrScanCallToActionRoute from "./routes/qrScanCallToAction/QrScanCallToAction";
import NewDashboardRoute from "./routes/newDashboardRouteeee/NewDashboardRouteeeee";

function App() {
  console.log("App mounted");
  const location = useLocation();
  const isNewRoute = location.pathname.startsWith("/new");
  // function onClose() {
  //   console.log("close");
  // }

  // const { accountSetupCompleted } = useUser();

  return (
    <>
      <ScrollToTop />
<NewPage>
        <Routes>
          <Route path="/" element={<NewHomeRoute />} />
          <Route path="*" element={<NewHomeRoute />} />
          <Route path="/app" element={<NewApp />} />
          <Route path="/map" element={<NewMap />} />
          <Route path="/marketplace" element={<NewMarketplaceRoute />} />
          <Route path="/marketplace/:id" element={<ProductDetailPage />} />
          <Route path="/dashboard" element={<NewDashboardRoute />} />
          <Route path="/industries" element={<NewIndustriesRoute />} />
          <Route path="/references" element={<NewReferencesRoute />} />
          <Route path="/team" element={<NewTeamRoute />} />
          <Route path="/meeting" element={<NewMeetingRoute />} />

          {/* Legacy use-case routes — redirect to the industries page anchors.
              The original route components are kept in src/routes/ for reference. */}
          <Route
            path="/use-cases/"
            element={<Navigate to="/industries" replace />}
          />
          <Route
            path="/use-cases/bike-parking"
            element={<Navigate to="/industries#parking" replace />}
          />
          <Route
            path="/use-cases/bike-sharing"
            element={<Navigate to="/industries#rental" replace />}
          />
          <Route
            path="/use-cases/design-your-own"
            element={<Navigate to="/industries#custom" replace />}
          />
          <Route path="/use-cases/smart-city" element={<SmartCityRoute />} />

          {/*Translations missing*/}
          <Route path="/pricing" element={<NewPricingRoute />} />
          <Route path="/web-app" element={<NewWebAppRoute />} />
          <Route path="/billing" element={<NewBillingRoute />} />
          <Route path="/docs" element={<NewDocsRoute />} />
          <Route path="/identity" element={<NewIdentityRoute />} />
          <Route path="/digital-twins" element={<NewDigitalTwinsRoute />} />
          <Route path="/locking-systems" element={<NewLockingSystemsRoute />} />
          <Route path="/bike-parking-showroom" element={<BikeParkingRoute />} />
          <Route
            path="/qr/fiveLetterQr/:fiveLetterQr"
            element={<QrScanCallToActionRoute />}
          />
          <Route path="/download" element={<QrScanCallToActionRoute />} />
          <Route
            path="/rent/bikebox/:fiveLetterQr"
            element={<QrScanCallToActionRoute />}
          />
        </Routes>
      </NewPage>
    </>
  );
}

export default App;
